import { combineReducers } from 'redux';

import countdown from './countdown.reducer';

export default combineReducers({
  countdown,
});
